<template>
  <div style="color:#fff" class="leftBar">
    <v-drawer :direction="'left'" :width="'26%'">
      <div class="animated fadeInLeftBig" style="height:100%;width:100%;">
        <bar-card class="lefts" :bg="'border2'">
          <v-title>基地种植规模排行</v-title>
          <div class="panelContent">
            <left-top />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border2'">
          <v-title>种植面积分布/品种占比(2023)</v-title>
          <div class="panelContent">
            <left-mid />
          </div>
        </bar-card>
        <bar-card class="lefts lefts3" :bg="'border2'">
          <v-title>种植基地</v-title>
          <div class="panelContent">
            <left-bot />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import leftTop from "./leftBar/leftTop";
import leftMid from "./leftBar/leftMid";
import leftBot from "./leftBar/leftBot";
export default {
  components: { leftTop, leftBot, leftMid },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.panelContent
  height calc(100% - 43px)
  color #fff
.lefts
  height 40%
  margin-bottom 10px
.lefts2
    height calc(30% - 10px)
    margin-bottom 10px
.lefts3
    height 30%
@media (min-height 1400px)
  .leftBar
    >>>.side
      width 24% !important
</style>
